
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class ProductPlanDimensions {
	static microsoft365: ProductPlanDimensionsType = 'OFFICE365';

	static values = ['OFFICE365'];
}
export type ProductPlanDimensionsType = 'OFFICE365';

